import React from 'react';
import { Link } from 'react-router-dom';

const PortfolioV1 = () => {
  const publicUrl = process.env.PUBLIC_URL || '';

  return (
    <div id="projet" className="container mb-5">
      {/* Titre de section */}
      <div className="row mt-5 mb-4">
        <div className="col text-center">
          {/* <h6 className="text-secondary">Nos équipes commerciales sont à votre écoute</h6> */}
          <h1 className="fw-bold">Nos Projets</h1>
        </div>
      </div>

      {/* Grille des projets */}
      <div className="row g-4">
        {/* Projet 1 */}
        <div className="col-lg-4 col-md-6">
          <Link to="/Diamantine" className="text-decoration-none text-dark">
            <div className=" h-100 ">
              <img
                src={`${publicUrl}/assets/img/gallery/facadeNuit.jpg`}
                className="card-img-top"
                alt="Facade Nuit"
              />
              <div className="card-body">
                <h5 className="card-title"> Projet Diamantine</h5>
                <p className="card-text">Une adresse d'exception, un investissement rentable.</p>
              </div>
            </div>
          </Link>
        </div>

        {/* Projet 2 */}
        <div className="col-lg-4 col-md-6">
          <Link to="/Ezzahara" className="text-decoration-none text-dark">
            <div className=" h-100 ">
              <img
                src={`${publicUrl}/assets/img/gallery/ezzahara.jpg`}
                className="card-img-top"
                alt="Ezzahara"
              />
              <div className="card-body">
                <h5 className="card-title"> Ezzahara Projet</h5>
                <p className="card-text">Une opportunité rare pour vivre ou investir à deux pas de la mer</p>
              </div>
            </div>
          </Link>
        </div>

        {/* Projet 3 */}
        <div className="col-lg-4 col-md-6">
          <a href="#contact" className="text-decoration-none text-dark">
            <div className=" h-100 ">
              <img
                src={`${publicUrl}/assets/img/gallery/rocade9.jpg`}
                className="card-img-top"
                alt="Rocade 9"
              />
              <div className="card-body">
                <h5 className="card-title"> Rocade 9 Projet</h5>
                <p className="card-text">(En cours d'autorisation)</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PortfolioV1;
